import { READ_PROFILES_FROM_FORAGE, RESET_PROFILES, SET_PROFILE, REMOVE_PROFILE } from './constants'

export function setProfiles(profiles) {
    return {
        type: READ_PROFILES_FROM_FORAGE,
        payload: profiles,
    }
}

export function resetProfiles() {
    return { type: RESET_PROFILES }
}

export function setUserProfile(serverId, userId, profile) {
    return {
        type: SET_PROFILE,
        payload: { serverId, userId, profile },
    }
}

export function removeUserProfile(serverId, userId) {
    return {
        type: REMOVE_PROFILE,
        payload: { serverId, userId },
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/profiles/actions.js